module.exports = __webpack_public_path__ + "img/b4a78f8.svg";